import { render, staticRenderFns } from "./webedit.vue?vue&type=template&id=4a1128e4&scoped=true&"
import script from "./webedit.vue?vue&type=script&lang=js&"
export * from "./webedit.vue?vue&type=script&lang=js&"
import style0 from "./webedit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./webedit.vue?vue&type=style&index=1&id=4a1128e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1128e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a1128e4', component.options)
    } else {
      api.reload('4a1128e4', component.options)
    }
    module.hot.accept("./webedit.vue?vue&type=template&id=4a1128e4&scoped=true&", function () {
      api.rerender('4a1128e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\reports\\webedit.vue"
export default component.exports